//@dependencies
import PropTypes from "prop-types";
//styles
import styles from "./Popup.module.scss";
import { CircularProgress, Grid2, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../CustomButton/CustomButton";
import SlidingPane from "react-sliding-pane";
import { useEffect, useState, useRef } from "react";

export default function NewPopup(props) {
  //props and hooks
  const {
    trigger,
    closePopup,
    backPopup,
    children,
    header,
    removed,
    nextpopup,
    nextOnClick,
    backOnClick,
    loading,
    disabled,
    customWidth,
    ...rest
  } = props;

  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const popupRef = useRef(null);
  useEffect(() => {
    setIsPaneOpen(trigger);
  }, [trigger]);

  useEffect(() => {
    document.body.style.overflow = isPaneOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isPaneOpen]);

  return trigger ? (
    <SlidingPane
      isOpen={isPaneOpen}
      from={isMobile ? "bottom" : "right"}
      width={isMobile ? "100%" : customWidth || "26%"}
      onRequestClose={() => {
        setIsPaneOpen(false);
        if (closePopup) closePopup();
      }}
      className={`${styles.slidePane} yourCustomClassName`}
      hideHeader
    >
      <Grid2 {...rest} className={styles.SlidingPaneContainer} ref={popupRef}>
        <Grid2 className={styles.DomainContainer}>
          <Grid2 className={styles.lineHeader}>
            <Grid2 {...rest} item className={styles.addDomainHeader}>
              <Grid2 className={styles.header}>{header}</Grid2>
              {closePopup ? (
                removed ? (
                  ""
                ) : (
                  <Grid2
                    onClick={() => {
                      closePopup();
                    }}
                  >
                    <CloseIcon className={styles.popupCloseButton} />
                  </Grid2>
                )
              ) : (
                ""
              )}
            </Grid2>
            <Grid2 className={styles.line} />
          </Grid2>
          <Grid2 className={styles.children}>{children}</Grid2>
        </Grid2>
        <Grid2 className={styles.buttonContainer}>
          {backPopup ? (
            <Grid2 className={styles.backPopup} onClick={backOnClick}>
              {backPopup}
            </Grid2>
          ) : (
            <Grid2 />
          )}
          {nextpopup && (
            <CustomButton
              className={styles.nextpopup}
              onClick={nextOnClick}
              disabled={disabled}
            >
              {loading ? (
                <CircularProgress size={25} color={"inherit"} />
              ) : (
                nextpopup
              )}
            </CustomButton>
          )}
        </Grid2>
      </Grid2>
    </SlidingPane>
  ) : null;
}

NewPopup.propTypes = {
  trigger: PropTypes.bool,
  closePopup: PropTypes.func,
  backPopup: PropTypes.string,
  nextpopup: PropTypes.string,
  children: PropTypes.node,
  header: PropTypes.string,
  nextOnClick: PropTypes.func,
  backOnClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};
